<template>
  <div class="signup">
    <form @submit.prevent="Signup">
      <label>Email:</label>
      <input type="email" required v-model="email">
      <label>Password:</label>
      <input type="password" required v-model="password">
      <div v-if="passwordError" class="error">{{ passwordError }}</div>
      <label>Beta Key:</label>
      <input type="text" required v-model="betaKey">
      <div class="terms">
        <input type="checkbox" required v-model="terms" />
        <label>Accept terms and conditions</label>
      </div>
      <input type="Submit" value="Sign Up">
      <p><router-link to="Login">Log in to existing account</router-link></p>
    </form>
  </div>
</template>

<script>
import { ref } from 'vue'
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth"
import { useStore } from 'vuex'

export default {
  setup() {
    const email = ref("")
    const password = ref("")
    const passwordError = ref("")
    const terms = ref(false)
    const store = useStore()
    const betaKey = ref("")

    const Signup = () => {
      // run validation checks on form
      passwordError.value = password.value.length > 5 ? '' : 'Password must be at least 6 characters long'
      
      if (passwordError.value) {
        return
      }

      if (betaKey.value!="1337") {
        passwordError.value = "Sorry, product is still in beta"
        return
      }

      const auth = getAuth()
      
      createUserWithEmailAndPassword(auth, email.value, password.value)
      .then((userCredential) => {
        // User created and signed in successfully
        const user = userCredential.user
        store.dispatch('setCurrentUser', user)

      })
      .catch((error) => {
        //const errorCode = error.code
        //const errorMessage = error.message
        passwordError.value = error.code
      })
    }

    return {
      Signup,
      email,
      password,
      terms,
      passwordError,
      betaKey
    }
  }
}
</script>

<style scoped>
.signup {
  max-width: 420px;
  margin: 30px auto;
  background: white;
  text-align: left;
  padding: 40px;
  border-radius: 10px;
}
label {
  color: #1ba098;
  display: inline-block;
  margin: 25px 0 15px;
  font-size: 0.6em;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: bold;
}
input {
  display: block;
  padding: 10px 6px;
  width: 100%;
  box-sizing: border-box;
  border: none;
  border-bottom: 1px solid #ddd;
  color: #7f94a2;
}
input[type="checkbox"] {
  display: inline-block;
  width: 16px;
  margin: 0 10px 0 0;
  position: relative;
  top: 2px;
}
input[type="submit"] {
  background: #1ba098;
  border: 0;
  padding: 10px 20px;
  margin-top: 20px;
  color: white;
  border-radius: 20px;
}
input[type="submit"]:hover {
  background: #deb992;
}
.error {
  color: #ff0062;
  margin-top: 10px;
  font-size: 0.8em;
  font-weight: bold;
}
</style>